module.exports = __webpack_public_path__ + "static/img/floor.eb9e05d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floor.png
// module id = maRJ
// module chunks = 1